import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { currentTenantId } from '@/utils/admin-utils';
import { TeamItemDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-team-dashboard-page',
  templateUrl: './team-dashboard-page.component.html',
  styleUrls: ['./team-dashboard-page.component.scss']
})
export class TeamDashboardPageComponent {

  currentTenantId = currentTenantId();
  readonly team = input.required<TeamItemDto>();

  form!: FormGroup;

  selectedTeam?: TeamItemDto;

  onTeamSelected(team: TeamItemDto): void {
    this.selectedTeam = team;
  }
}
